/**
 * Dark/light switch (DEC-130, UI_SDD §R.12).
 *
 * Lives in the top bar rather than on the Settings page: §R.8 is admin-only and
 * a theme is a per-person, per-device preference, not workspace configuration.
 * Every profile can reach it here.
 *
 * The icon shows the theme it will switch TO, which is the convention users
 * arrive with; the label says so explicitly for anyone who finds that ambiguous.
 */
import { Moon, Sun } from 'lucide-react'
import { useEffect, useState } from 'react'

import { currentTheme, subscribe, toggleTheme, type Theme } from '../../theme'

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => currentTheme())

  useEffect(() => subscribe(setTheme), [])

  const target = theme === 'dark' ? 'light' : 'dark'
  const label = `Switch to ${target} theme`

  return (
    <button
      type="button"
      onClick={() => toggleTheme()}
      aria-label={label}
      title={label}
      className="flex items-center justify-center w-[30px] h-[30px] bg-fill-subtle border border-hairline-strong rounded-full text-muted transition-colors hover:text-accent-vivid hover:border-hover-edge-soft"
    >
      {theme === 'dark' ? (
        <Sun className="w-[15px] h-[15px]" />
      ) : (
        <Moon className="w-[15px] h-[15px]" />
      )}
    </button>
  )
}
